import { render, staticRenderFns } from "./VehicleInventory.vue?vue&type=template&id=2ea2cb1b&scoped=true"
import script from "./VehicleInventory.vue?vue&type=script&lang=js"
export * from "./VehicleInventory.vue?vue&type=script&lang=js"
import style0 from "./VehicleInventory.vue?vue&type=style&index=0&id=2ea2cb1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea2cb1b",
  null
  
)

export default component.exports